import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { ICON_BUTTON_WIDTH } from '../../../constants';

export const iconButtonStyles = ({ isSelected, isMobile }: { isSelected: boolean; isMobile: boolean }) => [
  css`
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    padding: ${theme.spacing(1)};
    transition: background 250ms ease-in-out;
    border-bottom: solid 2px transparent;
    min-width: ${ICON_BUTTON_WIDTH}px;
    :hover {
      background: ${theme.colors.neutral5};
    }
    svg {
      fill: ${theme.colors.neutral90};
      color: ${theme.colors.neutral90};
    }
  `,
  isSelected &&
    css`
      background: ${isMobile ? null : theme.colors.neutral10};
      :hover {
        background: ${theme.colors.neutral5};
      }
      color: ${isMobile ? theme.colors.icon.select : theme.colors.neutral90};
      svg {
        fill: ${isMobile ? theme.colors.icon.select : theme.colors.neutral90};
        color: ${isMobile ? theme.colors.icon.select : theme.colors.neutral90};
      }
    `,
  isSelected &&
    isMobile &&
    css`
      border-bottom: solid 2px ${theme.colors.icon.select};
    `,
  isMobile &&
    css`
      min-width: 60px;
    `,
];

export const popoverItemStyles = () => css`
  font-size: ${theme.fontSize(14)};
  height: auto;
  cursor: pointer;
  padding-top: 6px;
  padding-bottom: 6px;
`;

export const navItemStyles = ({
  isXsmall,
  isSelected,
  isMobile,
  truncate,
}: {
  isXsmall: boolean;
  isMobile: boolean;
  isSelected: boolean;
  truncate: any;
}) => {
  if (isXsmall) {
    return css([
      {
        transition: 'color 250ms ease-in-out',
        maxWidth: 175,
        fontSize: theme.fontSize(14),
        flexGrow: 1,
        textAlign: 'left',
      },
      truncate,
    ]);
  }

  return css([
    {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      color: isSelected && isMobile ? theme.colors.icon.select : theme.colors.neutral90,
      transition: 'color 250ms ease-in-out',
      maxWidth: 175,
    },
    truncate,
  ]);
};

export const topBarSectionStyles = css`
  align-items: center;
  color: ${theme.colors.white};
  display: flex;
  height: 100%;
  width: 100%;
  column-gap: ${theme.spacing(1)};

  @media (max-width: ${breakpoints.xsmall.max}px) {
    column-gap: 0;
    justify-content: space-between;

    & > * {
      flex-grow: 0;
      height: 100%;
    }

    & > .top-bar__ul {
      flex-grow: 2;
      justify-content: space-between;
    }
  }
`;
